// third-party
import { FormattedMessage } from 'react-intl';

// assets
import { ChromeOutlined, QuestionOutlined, DeploymentUnitOutlined, DatabaseOutlined } from '@ant-design/icons';

// type
import { NavItemType } from 'types/menu';

// icons
const icons = {
  ChromeOutlined,
  QuestionOutlined,
  DeploymentUnitOutlined,
  DatabaseOutlined
};

// ==============================|| MENU ITEMS - SUPPORT ||============================== //

const other: NavItemType = {
  id: 'other',
  // title: <FormattedMessage id="others" />,
  type: 'group',
  children: [
    {
      id: 'data-capture',
      title: <FormattedMessage id="data-capture" />,
      type: 'item',
      url: '/data-capture',
      icon: icons.DatabaseOutlined
    },
  ]
};

export default other;
